import { LocalStorage } from 'quasar'
import { Parse } from 'src/boot/parse'

export function parsePrototype ({ dispatch, state, rootState }, item = false) {
  const itemPrototype = (item === false) ? state.currentItem ? state.currentItem?.toJSON() : false : item

  if(!itemPrototype) return itemPrototype

  if (item === false) {
    delete itemPrototype.objectId
    delete itemPrototype._localId
  }

  itemPrototype.client = {
    __type: 'Pointer',
    className: '_User',
    objectId: rootState.auth.user.id
  }

  if (rootState.orders.current && rootState.orders.current.id) {
    itemPrototype.restaurant_order_summary = {
      __type: 'Pointer',
      className: 'RestaurantOrderSummary',
      objectId: rootState.orders.current.id
    }
  }

  const extras = itemPrototype.extras
  itemPrototype.extras = []

  if (extras && extras.length) {
    for (const i in extras) {

        itemPrototype.extras.push({
          __type: 'Pointer',
          className: 'RestaurantItemExtra',
          objectId: extras[i].objectId ? extras[i].objectId : extras[i].id
        })
    }
  }

  if(itemPrototype.meal) {
    itemPrototype.meal = {
      __type: 'Pointer',
      className: 'RestaurantItem',
      objectId: itemPrototype.meal.objectId
    }
  }

  if(itemPrototype.meal_group) {
    itemPrototype.meal_group = {
      __type: 'Pointer',
      className: 'MealGroup',
      objectId: itemPrototype.meal_group.objectId
    }
  }
  itemPrototype.business = rootState.business.business
  return itemPrototype
}

export async function newItem ({ commit, rootState }, itemData) {
  commit('CART_RESET_CURRENT_ITEM')
  commit('CART_SET_CURRENT_ITEM', await new Parse.Object('RestaurantOrder', {
    ...itemData,
    business: rootState.business.business
  }))
}

export async function editItem ({ commit, state }, itemIndex) {
  commit('CART_RESET_EXTRAS')
  commit('CART_RESET_CURRENT_ITEM')
  commit('CART_SET_CURRENT_ITEM', state.items[itemIndex])
}

export async function updateItem ({ commit, dispatch, state }, { itemIndex, orderItemData }) {
  for (const i in orderItemData) {
    state.currentItem.set(i, orderItemData[i])
  }
  commit('CART_UPDATE_CURRENT_ITEM', itemIndex)
  commit('CART_RESET_EXTRAS')
}

// export async function toggleExtra ({ commit, rootState }, { extra, status }) {
//   if (!extra.id) {
//     extra = rootState.items.extras[extra.objectId]
//   }

//   if (status === undefined) {
//     commit('ITEMS_CART_TOGGLE_ITEM_EXTRA', extra)
//   } else {
//     commit('ITEMS_CART_SET_ITEM_EXTRA', { extra: extra, status: status })
//   }
// }

export async function saveItem ({ commit, dispatch, state, rootState }, { amount, orderItemData }) {
  commit('CART_LOADING', true)

  if(!state.currentItem) {
    return false
  }
  const itemPrototype = Object.assign(await dispatch('parsePrototype'), orderItemData)
  const promises = []

  const items = []
  for (let i = 0; i < amount; i++) {
    items[i] = JSON.parse(JSON.stringify(itemPrototype))
    items[i].restaurant_item = state.currentItem.get('restaurant_item')
    items[i].business = rootState.business.business
    promises.push(new Parse.Object('RestaurantOrder', items[i]))
  }
  return Promise.all(promises).then((savedItems) => {
    // console.log('saved items', savedItems)
    commit('CART_ADD_ITEMS', savedItems)
    commit('CART_RESET_EXTRAS')
    commit('CART_RESET_CURRENT_ITEM')
    commit('CART_LOADING', false)
    return savedItems
  })
}

export async function deleteCurrentItem ({ commit, state }) {
  state.currentItem.destroy()
}

export async function deleteItem ({ commit, state }, itemIndex) {
  return await state.items[itemIndex].destroy().then(() => {
    commit('CART_DELETE_ITEM', itemIndex)
  })
}

export async function removeItems ({ commit, dispatch, state }) {
  while (state.items.length) {
    const items = state.items
    for (const i in items) {
      commit('CART_DELETE_ITEM', i)
    }
  }
}

export function reset ({ commit }) {
  commit('CART_RESET')
  commit('CART_SET_SCHEDULED_AT', false)
  commit('CART_SET_SPECIAL_REQUEST', '')
  commit('tables/TABLES_SET_PRESET_TABLE_ID', '', { root: true })
  commit('tables/TABLES_SET_PIN', '', { root: true })
}

export function resetCurrentItem ({ commit }) {
  commit('CART_RESET_CURRENT_ITEM')
  commit('CART_RESET_EXTRAS')
}

export async function refresh ({ commit, dispatch, rootState }) {
  commit('CART_LOADING', true)

  let items = LocalStorage.has('cart.items') ? LocalStorage.getItem('cart.items') : false
  if (items === null) {
    items = []
  }

  if (items && items.length) {
    for (const i in items) {
      items[i] = await new Parse.Object('RestaurantOrder', await dispatch('parsePrototype', items[i]))
    }
    commit('CART_SET_ITEMS', { items: items, order: rootState.orders.current })
  }

  commit('CART_READY')
  commit('CART_LOADING', false)
}

// export async function saveMeal({ state, commit, dispatch, rootState},  mealData) {
//   commit('CART_LOADING', true)
//   // console.log('save meal', mealData)
//   const meal_items = mealData.meal_items
//   delete mealData.meal_items
//   const itemPrototype = Object.assign(await dispatch('parsePrototype'), mealData)

//   const order = JSON.parse(JSON.stringify(itemPrototype))

//   const mealOrder = new Parse.Object('RestaurantOrder', order)
//   mealOrder.set('meal_items', meal_items)
//   // console.log('saved meal', mealOrder)
//   commit('ADD_MEAL_ORDER', mealOrder)
//   commit('CART_RESET_EXTRAS')
//   commit('CART_RESET_CURRENT_ITEM')
//   commit('CART_LOADING', false)
//   return mealOrder
// }